<template>
  <div>
    <ul class="tabs l-flex-row">
      <li
        class="tab"
        v-for="tab in dataTabs"
        :key="tab.label"
        :class="{ 'is-active': tab.label === activeTab }"
        @click.prevent="setTab(tab.label)"
      >
        <div class="tab-label">
          {{ tab.label }}
        </div>
      </li>
    </ul>


    <slot name="content" />
  </div>
</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapMutations } from 'vuex'

export default {
    name: 'Tabs',
    props: {
        dataTabs: {
            type: Array,
            required: true
        },
        parent: {
            type: String,
            required: true
        }
    },

    computed: {
        // Call to state
        ...mapState('ui/builder', {
            activeTabBuilder: state => state.metrics.activeTabBuilder,
            activeTabBuilderCclones: state => state.cclone.activeTab
        }),
        ...mapState('ui/monitoring', {
            activeTabAudiences: state => state.activeTab
        }),
        ...mapState('ui/transfers', {
            activeTabTransfers: state => state.activeTab
        }),
        ...mapState('ui/dataEntry', {
            activeTabJobs: state => state.activeTab
        }),
        ...mapState('ui/manageTaxonomy', {
            activeTabTaxonomies: state => state.activeTab
        }),
        ...mapState('ui/cclone', {
            activeTabCclones: state => state.activeTab
        }),
        ...mapState('ui/georadar', {
            activeTabGeoradar: state => state.activeTab
        }),

        activeTab() {
            if (this.parent === 'builder') return this.activeTabBuilder
            else if (this.parent === 'builderCclones') return this.activeTabBuilderCclones
            else if (this.parent === 'audiences') return this.activeTabAudiences
            else if (this.parent === 'transfers') return this.activeTabTransfers
            else if (this.parent === 'jobs') return this.activeTabJobs
            else if (this.parent === 'taxonomies') return this.activeTabTaxonomies
            else if (this.parent === 'cclones') return this.activeTabCclones
            else if (this.parent === 'georadar') return this.activeTabGeoradar
            return ''
        }
    },

    methods: {
        // Call to mutations
        ...mapMutations('ui/builder', ['setActiveTabBuilder', 'setActiveTabBuilderCclone']),
        ...mapMutations('ui/manageTaxonomy', ['setActiveTabManageTaxo']),
        ...mapMutations('ui/cclone', { setActiveTabCclone: 'setActiveTab' }),
        ...mapMutations('ui/monitoring', { setActiveTabAudience: 'setActiveTab' }),
        ...mapMutations('ui/dataEntry', { setActiveTabJobs: 'setActiveTab' }),
        ...mapMutations('ui/georadar', { setActiveTabGeoradar: 'setActiveTab' }),
        ...mapMutations('ui/transfers', { setActiveTabTransfer: 'setActiveTab' }),

        setTab(selectedTab) {
            if (this.parent === 'builder') this.setActiveTabBuilder({ tab: selectedTab })
            else if (this.parent === 'builderCclones') this.setActiveTabBuilderCclone({ tab: selectedTab })
            else if (this.parent === 'taxonomies') this.setActiveTabManageTaxo({ tab: selectedTab })
            else if (this.parent === 'cclones') this.setActiveTabCclone({ tab: selectedTab })
            else if (this.parent === 'audiences') this.setActiveTabAudience({ tab: selectedTab })
            else if (this.parent === 'jobs') this.setActiveTabJobs({ tab: selectedTab })
            else if (this.parent === 'georadar') this.setActiveTabGeoradar({ tab: selectedTab })
            else if (this.parent === 'transfers') this.setActiveTabTransfer({ tab: selectedTab })
        }
    }
}
</script>
